var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sentence-frame",on:{"mousemove":_vm.sentenceFrameTracking}},[(_vm.show)?_c('div',{ref:"frameTop",staticClass:"sentence-frame-top"}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.show)?_c('div',{ref:"frameBottom",staticClass:"sentence-frame-bottom"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }